module.exports = __webpack_public_path__ + "static/partnership_hand-20a28e249b68e46c6677a956db3b801e.png";